// src/views/relatorios/RelatoriosList.jsx
import React, { useState, useEffect } from "react";
import unidadesService   from "../../services/unidadesService";
import relatoriosService  from "../../services/relatoriosService";
import contasContabeisService from "../../services/contasContabeisService";
import { useAuth } from "../../contexts/AuthContext";
import Banner       from "../../components/ui/Banner";
import ConfirmModal from "../../components/ui/ConfirmModal";

const fmtM = v => Number(v||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});
const fmtD = d => { try{ return new Date(d+"T12:00:00").toLocaleDateString("pt-BR"); }catch{ return d||"—"; } };

// ── Primeiro e último dia do mês atual ────────────────────────────────────
function primeiroDiaMes() {
  const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-01`;
}
function ultimoDiaMes() {
  const d = new Date(); return new Date(d.getFullYear(), d.getMonth()+1, 0).toISOString().split("T")[0];
}

// ── Componente de linha de grupo ──────────────────────────────────────────
function GrupoReceita({ grupo }) {
  const [open, setOpen] = useState(true);
  return (
    <div style={{ marginBottom:6 }}>
      <div onClick={() => setOpen(p=>!p)}
        style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
          background:"var(--bg-highlight)", padding:"8px 14px", borderRadius:8, cursor:"pointer",
          border:"1px solid #BFDBFE" }}>
        <span style={{ fontWeight:700, fontSize:13, color:"#1D4ED8", display:"flex", alignItems:"center", gap:6 }}>
          <i className={`bi bi-chevron-${open?"down":"right"}`} style={{ fontSize:11 }}/>
          {grupo.descricao}
        </span>
        <span style={{ fontWeight:700, color:"#1D4ED8", fontSize:13 }}>{fmtM(grupo.total)}</span>
      </div>
      {open && grupo.itens.map((item,i) => (
        <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
          padding:"6px 14px 6px 28px", background:"#F8FAFF",
          borderBottom:"1px solid #EFF6FF", fontSize:12.5 }}>
          <span style={{ color:"var(--gray-600)" }}>
            {item.classificacaoContabil && <span style={{ color:"var(--gray-300)", marginRight:6, fontSize:11 }}>{item.classificacaoContabil}</span>}
            {item.descConta || "Sem conta contábil"}
            {item.qtd > 0 && <span style={{ color:"var(--gray-400)", fontSize:11, marginLeft:6 }}>({item.qtd} lanç.)</span>}
          </span>
          <span style={{ fontWeight:600, color:"#1D4ED8" }}>{fmtM(item.vlrRealizado)}</span>
        </div>
      ))}
    </div>
  );
}

function GrupoDespesa({ grupo }) {
  const [open, setOpen] = useState(true);
  return (
    <div style={{ marginBottom:6 }}>
      <div onClick={() => setOpen(p=>!p)}
        style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
          background:"var(--bg-danger-soft)", padding:"8px 14px", borderRadius:8, cursor:"pointer",
          border:"1px solid #FECACA" }}>
        <span style={{ fontWeight:700, fontSize:13, color:"#991B1B", display:"flex", alignItems:"center", gap:6 }}>
          <i className={`bi bi-chevron-${open?"down":"right"}`} style={{ fontSize:11 }}/>
          {grupo.descricao}
        </span>
        <span style={{ fontWeight:700, color:"#991B1B", fontSize:13 }}>{fmtM(grupo.total)}</span>
      </div>
      {open && grupo.itens.map((item,i) => (
        <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
          padding:"6px 14px 6px 28px", background:"#FFF8F8",
          borderBottom:"1px solid #FEF2F2", fontSize:12.5 }}>
          <span style={{ color:"var(--gray-600)" }}>
            {item.classificacaoContabil && <span style={{ color:"var(--gray-300)", marginRight:6, fontSize:11 }}>{item.classificacaoContabil}</span>}
            {item.descConta || "Sem conta contábil"}
            {item.qtd > 0 && <span style={{ color:"var(--gray-400)", fontSize:11, marginLeft:6 }}>({item.qtd} lanç.)</span>}
          </span>
          <span style={{ fontWeight:600, color:"#991B1B" }}>{fmtM(item.vlrRealizado)}</span>
        </div>
      ))}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
export default function RelatoriosList({ abaInicial = "dre", mostrarTabs = true }) {
  const { condominioAtivo } = useAuth();
  const [aba, setAba]             = useState(abaInicial);
  const [idCondo, setIdCondo]     = useState("");
  const [dtIni, setDtIni]         = useState(primeiroDiaMes());
  const [dtFim, setDtFim]         = useState(ultimoDiaMes());
  const [data, setData]           = useState(null);
  const [loading, setLoading]     = useState(false);
  const [printing, setPrinting]   = useState(false);
  // Inadimplência specific filters
  const [dtRefInad,    setDtRefInad]    = useState(new Date().toISOString().split("T")[0]);
  const [diasMinInad,  setDiasMinInad]  = useState("0");
  const [tpBoletoInad, setTpBoletoInad] = useState("");
  const [diasMaxInad,  setDiasMaxInad]  = useState("");
  const [blocoInad,    setBlocoInad]    = useState("");
  const [idUnidadeInad,setIdUnidadeInad]= useState("");
  const [orderByInad,  setOrderByInad]  = useState("diasAtraso");
  const [competenciaInad, setCompetenciaInad] = useState("");
  // Extrato Analítico
  const [contasContabeis, setContasContabeis] = useState([]);
  const [idContaFiltro,   setIdContaFiltro]   = useState("");
  // Pre-existing filters
  const [idUnidade,     setIdUnidade]     = useState("");
  const [filtroConsumo, setFiltroConsumo] = useState("");
  const [unidades,      setUnidades]      = useState([]);

  // ── Banner global + ConfirmModal global (substitui alert/confirm nativos) ──
  const [banner, setBanner]           = useState(null); // {mensagem, tipo}
  const [confirmacao, setConfirmacao] = useState(null); // {titulo, mensagem, textoOk, perigo, resolve}
  const notify = (mensagem, tipo = "info") => {
    setBanner({ mensagem, tipo });
    setTimeout(() => setBanner(null), 5000);
  };
  const askConfirm = (opts) =>
    new Promise(resolve => setConfirmacao({ ...opts, resolve }));

  // Sync with navbar condominioAtivo — updates whenever user changes it
  useEffect(() => {
    if (condominioAtivo?.id) setIdCondo(String(condominioAtivo.id));
    else setIdCondo("");
  }, [condominioAtivo]);

  useEffect(() => {
    if (!idCondo) return;
    contasContabeisService.listar({ idCondominio:idCondo, situacao:"ativo", natureza:"Analitica" })
      .then(r => setContasContabeis(r.data||[]))
      .catch(()=>{});
  }, [idCondo]);

  useEffect(() => {
    if (!idCondo) return;
    import("../../services/unidadesService").then(m =>
      m.default.listar({ idCondominio:idCondo, limit:500 })
        .then(r => setUnidades(r.data||[]))
        .catch(()=>{})
    );
  }, [idCondo]);
  // Reset data when tab changes
  useEffect(() => { setData(null); }, [aba]);

  const handleGerar = async () => {
    if (!idCondo) { notify("Selecione o condomínio.", "warning"); return; }
    if (aba !== "inadimplencia" && (!dtIni || !dtFim)) { notify("Preencha o período.", "warning"); return; }
    setLoading(true); setData(null);
    try {
      let r;
      if (aba === "dre") {
        r = await relatoriosService.dre({ idCondominio:idCondo, dtIni, dtFim });
      } else if (aba === "balancete") {
        r = await relatoriosService.balancete({ idCondominio:idCondo, dtIni, dtFim });
      } else if (aba === "demonstrativo") {
        r = await relatoriosService.demonstrativo({ idCondominio:idCondo, dtIni, dtFim });
      } else if (aba === "extrato") {
        if (!idUnidade) { notify("Selecione a unidade.", "warning"); setLoading(false); return; }
        r = await relatoriosService.extrato({ idCondominio:idCondo, idUnidade, dtIni, dtFim });
      } else if (aba === "prestacao") {
        r = await relatoriosService.prestacao({ idCondominio:idCondo, dtIni, dtFim });
      } else if (aba === "consumo") {
        r = await relatoriosService.consumo({ idCondominio:idCondo, dtIni, dtFim, tpConsumo:filtroConsumo });
      } else if (aba === "inadimplencia") {
        r = await relatoriosService.inadimplencia({
          idCondominio:idCondo, dtReferencia:dtRefInad,
          diasMinimos:diasMinInad, diasMaximos:diasMaxInad,
          tpBoleto:tpBoletoInad, bloco:blocoInad,
          idUnidade:idUnidadeInad, orderBy:orderByInad,
          competencia:competenciaInad,
        });
      } else if (aba === "extrato-analitico") {
        r = await relatoriosService.extratoAnalitico({
          idCondominio:idCondo, dtIni, dtFim,
          idContaContabil:idContaFiltro,
        });
      }
      setData(r);
    } catch(e) { notify(e?.message || "Erro ao gerar relatório. Verifique os filtros.", "danger"); }
    setLoading(false);
  };

  const handleExportar = async () => {
    if (!idCondo) { notify("Selecione o condomínio.", "warning"); return; }
    try {
      await relatoriosService.exportarExcel({
        tipo: aba === "extrato-analitico" ? "extrato-analitico" : aba,
        idCondominio: idCondo,
        dtIni, dtFim,
        dtReferencia: dtRefInad,
        diasMinimos: diasMinInad,
        diasMaximos: diasMaxInad,
        idContaContabil: idContaFiltro,
      });
    } catch(e) { notify(e?.message || "Erro ao exportar.", "danger"); }
  };

  const handleImprimir = async () => {
    if (!idCondo) return;
    setPrinting(true);
    try {
      let r;
      if (aba === "dre") {
        r = await relatoriosService.imprimirDRE({ idCondominio:idCondo, dtIni, dtFim });
      } else if (aba === "balancete") {
        r = await relatoriosService.imprimirBalancete({ idCondominio:idCondo, dtIni, dtFim });
      } else if (aba === "extrato") {
        if (!idUnidade) { notify("Selecione a unidade.", "warning"); setPrinting(false); return; }
        r = await relatoriosService.imprimirExtrato({ idCondominio:idCondo, idUnidade, dtIni, dtFim });
      } else if (aba === "extrato-analitico") {
        r = await relatoriosService.imprimirExtrato({ idCondominio:idCondo, dtIni, dtFim, tipo:"extrato-analitico", idContaContabil:idContaFiltro });
      } else if (aba === "prestacao") {
        r = await relatoriosService.imprimirPrestacao({ idCondominio:idCondo, dtIni, dtFim });
      } else if (aba === "consumo") {
        r = await relatoriosService.imprimirConsumo({ idCondominio:idCondo, dtIni, dtFim, tpConsumo:filtroConsumo });
      } else if (aba === "demonstrativo") {
        r = await relatoriosService.imprimirDemonstrativo({ idCondominio:idCondo, dtIni, dtFim });
      } else if (aba === "inadimplencia") {
        r = await relatoriosService.imprimirInadimplencia({
          idCondominio:idCondo, dtReferencia:dtRefInad,
          diasMinimos:diasMinInad, tpBoleto:tpBoletoInad,
        });
      }
      if (r?.html) {
        const blob = new Blob([r.html], {type:"text/html;charset=utf-8"});
        const url  = URL.createObjectURL(blob);
        const w    = window.open(url, "_blank", "width=950,height=950");
        if (w) { w.onload = () => setTimeout(()=>w.print(), 500); }
        else {
          const a = document.createElement("a"); a.href=url; a.download="relatorio.html";
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
        }
        setTimeout(()=>URL.revokeObjectURL(url), 30000);
      }
    } catch(e) { notify(e?.message || "Erro ao gerar impressão.", "danger"); }
    setPrinting(false);
  };

  const condoNome = condominioAtivo?.nmFantasia || condominioAtivo?.nmCondominio || "";
  const resultado = data?.resultadoLiquido;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">
            <i className="bi bi-bar-chart-line me-2" style={{color:"var(--primary)",fontSize:22}}/>
            {{
              "dre":"Relatórios Financeiros",
              "balancete":"Relatórios Financeiros",
              "extrato-analitico":"Relatórios Financeiros",
              "prestacao":"Relatórios Financeiros",
              "inadimplencia":"Rel. de Gestão",
              "extrato":"Rel. de Gestão",
              "consumo":"Rel. de Gestão",
            }[aba]||"Relatórios"}
          </h1>
          <p className="page-subtitle">{{
              "dre":"DRE — Demonstrativo de Resultado do Exercício",
              "balancete":"Balancete por Conta Contábil",
              "demonstrativo":"Demonstrativo de Receitas e Despesas",
              "extrato-analitico":"Extrato Analítico por Conta Contábil",
              "prestacao":"Prestação de Contas",
              "inadimplencia":"Inadimplência — Boletos em Atraso",
              "extrato":"Extrato por Unidade",
              "consumo":"Consumo de Água e Gás",
            }[aba]||"Selecione um relatório"}</p>
        </div>
      </div>

      <div className="card">
        {/* Sub-abas — só mostra quando acesso via menu geral */}
        {mostrarTabs && <div style={{borderBottom:"1px solid var(--gray-200)",padding:"0 16px",display:"flex",gap:4}}>
          {[
            {id:"dre",      label:"DRE",      icon:"bi-graph-up",      desc:"Demonstrativo de Resultado"},
            {id:"balancete",    label:"Balancete",     icon:"bi-journal-text",    desc:"Por Conta Contábil"},
            {id:"demonstrativo", label:"Demonstrat. Rec/Desp", icon:"bi-file-earmark-spreadsheet", desc:"Receitas e Despesas"},
            {id:"inadimplencia", label:"Inadimplência",  icon:"bi-exclamation-circle",desc:"Devedores com atualização"},
            {id:"extrato",       label:"Extrato Unidade", icon:"bi-card-list",          desc:"Histórico por unidade"},
            {id:"prestacao",     label:"Prestação",       icon:"bi-file-earmark-bar-graph",desc:"Prestação de contas"},
            {id:"consumo",       label:"Consumo",         icon:"bi-droplet-half",          desc:"Água e Gás por unidade"},
          ].map(t=>(
            <button key={t.id}
              className="btn border-0 d-flex align-items-center gap-2"
              style={{fontSize:13, padding:"12px 16px", borderRadius:0,
                borderBottom:aba===t.id?"2px solid var(--primary)":"2px solid transparent",
                fontWeight:aba===t.id?700:400,
                color:aba===t.id?"var(--primary)":"var(--gray-500)",
                background:"transparent"}}
              onClick={()=>setAba(t.id)}>
              <i className={`bi ${t.icon}`}/>
              <span>{t.label}</span>
              {!loading && <span style={{fontSize:10,color:"var(--gray-400)"}}>({t.desc})</span>}
            </button>
          ))}
        </div>}

        <div style={{padding:16}}>
          {/* Filtros */}
          <div className="form-section">
            <div className="form-section-title"><i className="bi bi-funnel"/> {aba==="inadimplencia"?"Filtros":"Período"}</div>
            {condoNome && (
              <div style={{display:"inline-block",background:"var(--bg-highlight)",color:"#1D4ED8",
                padding:"4px 12px",borderRadius:14,fontSize:12,fontWeight:600,marginBottom:10}}>
                <i className="bi bi-building me-1"/>{condoNome}
              </div>
            )}
            <div className="row g-3 align-items-end">
              {aba==="consumo" && (
                <div className="col-md-3">
                  <label className="form-label">Tipo</label>
                  <select className="form-select" value={filtroConsumo} onChange={e=>setFiltroConsumo(e.target.value)}>
                    <option value="">Todos</option>
                    <option value="Agua">Água</option>
                    <option value="Gas">Gás</option>
                    <option value="Energia">Energia</option>
                  </select>
                </div>
              )}
              {aba==="extrato" && (
                <div className="col-md-4">
                  <label className="form-label">Unidade</label>
                  <select className="form-select" value={idUnidade} onChange={e=>setIdUnidade(e.target.value)}>
                    <option value="">Selecione a unidade</option>
                    {unidades.map(u=><option key={u.id} value={u.id}>{u.unidade}{u.bloco?`/Bl.${u.bloco}`:""} — {u.nmCondomino||"Vago"}</option>)}
                  </select>
                </div>
              )}
              {aba!=="inadimplencia" && <div className="col-md-2">
                <label className="form-label">Data Inicial</label>
                <input type="date" className="form-control" value={dtIni}
                  onChange={e=>{setDtIni(e.target.value);setData(null);}}/>
              </div>}
              {aba!=="inadimplencia" && <div className="col-md-2">
                <label className="form-label">Data Final</label>
                <input type="date" className="form-control" value={dtFim}
                  onChange={e=>{setDtFim(e.target.value);setData(null);}}/>
              </div>}
              {/* Atalhos de período */}
              {aba!=="inadimplencia" && <div className="col-md-4">
                <label className="form-label">Atalhos</label>
                <div className="d-flex gap-2 flex-wrap">
                  {[
                    {l:"Mês Atual",  f:()=>{setDtIni(primeiroDiaMes());setDtFim(ultimoDiaMes());}},
                    {l:"Trim. Atual",f:()=>{const d=new Date();const q=Math.floor(d.getMonth()/3);setDtIni(`${d.getFullYear()}-${String(q*3+1).padStart(2,"0")}-01`);const mf=q*3+3;setDtFim(new Date(d.getFullYear(),mf,0).toISOString().split("T")[0]);}},
                    {l:"Ano Atual",  f:()=>{const d=new Date();setDtIni(`${d.getFullYear()}-01-01`);setDtFim(`${d.getFullYear()}-12-31`);}},
                  ].map(a=>(
                    <button key={a.l} className="btn btn-outline-secondary btn-sm" style={{fontSize:11}}
                      onClick={()=>{a.f();setData(null);}}>
                      {a.l}
                    </button>
                  ))}
                </div>
              </div>}
              {/* Filtros exclusivos da Inadimplência */}
              {aba==="inadimplencia" && (<>
                <div className="col-md-2">
                  <label className="form-label">Data Referência</label>
                  <input type="date" className="form-control" value={dtRefInad}
                    onChange={e=>{setDtRefInad(e.target.value);setData(null);}}/>
                  <small style={{fontSize:10,color:"var(--gray-400)"}}>Calcula multa/juros até esta data</small>
                </div>
                <div className="col-md-2">
                  <label className="form-label">Mín. dias em atraso</label>
                  <input type="number" className="form-control" value={diasMinInad} min="0"
                    onChange={e=>{setDiasMinInad(e.target.value);setData(null);}}/>
                </div>
                <div className="col-md-2">
                  <label className="form-label">Tipo de Boleto</label>
                  <select className="form-select" value={tpBoletoInad}
                    onChange={e=>{setTpBoletoInad(e.target.value);setData(null);}}>
                    <option value="">Todos</option>
                    <option value="Normal">Normal</option>
                    <option value="Renegociacao">Renegociação</option>
                  </select>
                </div>
                <div className="col-md-2">
                  <label className="form-label">Máx. dias em atraso</label>
                  <input type="number" className="form-control" value={diasMaxInad} min="0"
                    placeholder="Sem limite"
                    onChange={e=>{setDiasMaxInad(e.target.value);setData(null);}}/>
                </div>
                <div className="col-md-2">
                  <label className="form-label">Bloco</label>
                  <input className="form-control" value={blocoInad} placeholder="Todos"
                    onChange={e=>{setBlocoInad(e.target.value);setData(null);}}/>
                </div>
                <div className="col-md-2">
                  <label className="form-label">Competência</label>
                  <input type="month" className="form-control" value={competenciaInad}
                    onChange={e=>{setCompetenciaInad(e.target.value);setData(null);}}/>
                  <small style={{fontSize:10,color:"var(--gray-400)"}}>Filtrar por mês de referência</small>
                </div>
                <div className="col-md-2">
                  <label className="form-label">Ordenar por</label>
                  <select className="form-select" value={orderByInad}
                    onChange={e=>{setOrderByInad(e.target.value);setData(null);}}>
                    <option value="diasAtraso">Dias em atraso</option>
                    <option value="unidade">Unidade</option>
                    <option value="condomino">Condômino</option>
                    <option value="valor">Valor</option>
                    <option value="vencimento">Vencimento</option>
                  </select>
                </div>
              </>)}
              {aba==="extrato-analitico" && (
                <div className="col-md-4">
                  <label className="form-label">Conta Contábil (opcional)</label>
                  <select className="form-select" value={idContaFiltro}
                    onChange={e=>{setIdContaFiltro(e.target.value);setData(null);}}>
                    <option value="">Todas as contas</option>
                    {contasContabeis.map(ct=>(
                      <option key={ct.id} value={ct.id}>
                        {ct.classificacaoContabil ? `${ct.classificacaoContabil} — ` : ""}{ct.descConta}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div className="col-md-4 d-flex gap-2">
                <button className="btn btn-primary" onClick={handleGerar} disabled={loading||!idCondo}>
                  {loading
                    ? <><span className="spinner-border spinner-border-sm me-2"/>Gerando...</>
                    : <><i className="bi bi-play-fill me-2"/>Gerar {aba==="dre"?"DRE":aba==="balancete"?"Balancete":aba==="inadimplencia"?"Inadimplência":aba==="extrato-analitico"?"Extrato Analítico":aba==="extrato"?"Extrato":aba==="prestacao"?"Prestação":aba==="consumo"?"Consumo":aba==="demonstrativo"?"Demonstrativo":"Relatório"}</>}
                </button>
                {data && (
                  <button className="btn btn-outline-success" onClick={handleExportar} style={{marginRight:6}}>
                    <i className="bi bi-file-earmark-excel me-1"/>Exportar Excel
                  </button>
                )}
                {data && (
                  <button className="btn btn-outline-secondary" onClick={handleImprimir} disabled={printing}>
                    {printing
                      ? <span className="spinner-border spinner-border-sm"/>
                      : <><i className="bi bi-printer me-1"/>Imprimir / PDF</>}
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* ── DRE ── */}
          {aba==="dre" && data && (
            <div>
              {/* Cards resumo */}
              <div className="row g-3 mb-4">
                <div className="col-md-3">
                  <div style={{background:"var(--bg-highlight)",borderRadius:10,padding:"16px",textAlign:"center"}}>
                    <div style={{fontSize:11,fontWeight:700,color:"#1D4ED8",marginBottom:4}}>TOTAL RECEITAS</div>
                    <div style={{fontSize:22,fontWeight:800,color:"#1D4ED8"}}>{fmtM(data.receitas.total)}</div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div style={{background:"var(--bg-danger-soft)",borderRadius:10,padding:"16px",textAlign:"center"}}>
                    <div style={{fontSize:11,fontWeight:700,color:"#991B1B",marginBottom:4}}>TOTAL DESPESAS</div>
                    <div style={{fontSize:22,fontWeight:800,color:"#991B1B"}}>{fmtM(data.despesas.total)}</div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div style={{background:resultado>=0?"#DCFCE7":"#FEE2E2",borderRadius:10,padding:"16px",textAlign:"center",border:`2px solid ${resultado>=0?"#22C55E":"#EF4444"}`}}>
                    <div style={{fontSize:11,fontWeight:700,color:resultado>=0?"#166534":"#991B1B",marginBottom:4}}>
                      {resultado>=0?"SUPERÁVIT":"DÉFICIT"}
                    </div>
                    <div style={{fontSize:22,fontWeight:800,color:resultado>=0?"#166534":"#991B1B"}}>{fmtM(resultado)}</div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div style={{background:"var(--bg-page)",borderRadius:10,padding:"16px",textAlign:"center"}}>
                    <div style={{fontSize:11,fontWeight:700,color:"var(--gray-600)",marginBottom:4}}>SALDO BANCÁRIO</div>
                    <div style={{fontSize:22,fontWeight:800,color:data.totalSaldoBancario>=0?"#166534":"#991B1B"}}>{fmtM(data.totalSaldoBancario)}</div>
                  </div>
                </div>
              </div>

              <div className="row g-4">
                {/* Receitas */}
                <div className="col-md-6">
                  <div style={{fontWeight:700,fontSize:14,color:"#1D4ED8",marginBottom:12,display:"flex",alignItems:"center",gap:6}}>
                    <i className="bi bi-arrow-down-circle-fill"/>RECEITAS
                  </div>
                  {data.receitas.grupos.length === 0
                    ? <div style={{textAlign:"center",color:"var(--gray-400)",padding:"24px 0",fontSize:13}}>Nenhuma receita no período</div>
                    : data.receitas.grupos.map((g,i) => <GrupoReceita key={i} grupo={g}/>)
                  }
                  <div style={{display:"flex",justifyContent:"space-between",padding:"10px 14px",background:"var(--bg-highlight)",borderRadius:8,fontWeight:700,fontSize:14,color:"#1D4ED8",marginTop:8}}>
                    <span>TOTAL RECEITAS</span>
                    <span>{fmtM(data.receitas.total)}</span>
                  </div>
                </div>

                {/* Despesas */}
                <div className="col-md-6">
                  <div style={{fontWeight:700,fontSize:14,color:"#991B1B",marginBottom:12,display:"flex",alignItems:"center",gap:6}}>
                    <i className="bi bi-arrow-up-circle-fill"/>DESPESAS
                  </div>
                  {data.despesas.grupos.length === 0
                    ? <div style={{textAlign:"center",color:"var(--gray-400)",padding:"24px 0",fontSize:13}}>Nenhuma despesa no período</div>
                    : data.despesas.grupos.map((g,i) => <GrupoDespesa key={i} grupo={g}/>)
                  }
                  <div style={{display:"flex",justifyContent:"space-between",padding:"10px 14px",background:"var(--bg-danger-soft)",borderRadius:8,fontWeight:700,fontSize:14,color:"#991B1B",marginTop:8}}>
                    <span>TOTAL DESPESAS</span>
                    <span>{fmtM(data.despesas.total)}</span>
                  </div>
                </div>

                {/* Passivo — Fundo de Reserva, Caução etc */}
                {data.passivo?.grupos?.length > 0 && (
                  <div className="col-12">
                    <div style={{fontWeight:700,fontSize:14,color:"#92400E",marginBottom:12,display:"flex",alignItems:"center",gap:6}}>
                      <i className="bi bi-safe2-fill"/>PASSIVO (Fundo de Reserva / Caução)
                    </div>
                    {data.passivo.grupos.map((g,i) => <GrupoReceita key={i} grupo={g}/>)}
                    <div style={{display:"flex",justifyContent:"space-between",padding:"10px 14px",background:"#FEF3C7",borderRadius:8,fontWeight:700,fontSize:14,color:"#92400E",marginTop:8}}>
                      <span>TOTAL PASSIVO ARRECADADO</span>
                      <span>{fmtM(data.passivo.total)}</span>
                    </div>
                  </div>
                )}
              </div>

              {/* Resultado Final */}
              <div style={{marginTop:20,padding:"16px 20px",background:resultado>=0?"#DCFCE7":"#FEE2E2",borderRadius:10,display:"flex",justifyContent:"space-between",alignItems:"center",border:`2px solid ${resultado>=0?"#22C55E":"#EF4444"}`}}>
                <span style={{fontWeight:700,fontSize:16,color:resultado>=0?"#166534":"#991B1B"}}>
                  RESULTADO LÍQUIDO DO PERÍODO
                </span>
                <span style={{fontWeight:800,fontSize:22,color:resultado>=0?"#166534":"#991B1B"}}>
                  {fmtM(resultado)}
                </span>
              </div>

              {/* Saldos bancários */}
              {data.saldosBancarios?.length > 0 && (
                <div style={{marginTop:16}}>
                  <div style={{fontWeight:700,fontSize:13,color:"var(--gray-700)",marginBottom:8}}>
                    <i className="bi bi-bank me-2"/>Posição de Caixa / Banco
                  </div>
                  <div className="row g-2">
                    {data.saldosBancarios.map((s,i) => (
                      <div key={i} className="col-md-4">
                        <div style={{background:"var(--gray-50)",borderRadius:8,padding:"10px 14px",border:"1px solid var(--gray-200)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                          <div>
                            <div style={{fontWeight:600,fontSize:12.5}}>{s.nmConta}</div>
                            <div style={{fontSize:11,color:"var(--gray-400)"}}>{s.banco}</div>
                          </div>
                          <div style={{fontWeight:700,fontSize:14,color:parseFloat(s.saldoAtual||0)>=0?"#166534":"#991B1B"}}>{fmtM(s.saldoAtual)}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* ── BALANCETE ── */}
          {aba==="balancete" && data && (
            <div>
              {/* Resumo */}
              <div className="row g-3 mb-4">
                <div className="col-md-4">
                  <div style={{background:"var(--bg-danger-soft)",borderRadius:10,padding:"16px",textAlign:"center"}}>
                    <div style={{fontSize:11,fontWeight:700,color:"#991B1B",marginBottom:4}}>TOTAL DÉBITOS</div>
                    <div style={{fontSize:20,fontWeight:800,color:"#991B1B"}}>{fmtM(data.totais.vlrDebito)}</div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div style={{background:"var(--bg-success-soft)",borderRadius:10,padding:"16px",textAlign:"center"}}>
                    <div style={{fontSize:11,fontWeight:700,color:"#166534",marginBottom:4}}>TOTAL CRÉDITOS</div>
                    <div style={{fontSize:20,fontWeight:800,color:"#166534"}}>{fmtM(data.totais.vlrCredito)}</div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div style={{background:"var(--bg-highlight)",borderRadius:10,padding:"16px",textAlign:"center"}}>
                    <div style={{fontSize:11,fontWeight:700,color:"#1D4ED8",marginBottom:4}}>CONTAS COM MOVIMENTO</div>
                    <div style={{fontSize:20,fontWeight:800,color:"#1D4ED8"}}>{data.contas.length}</div>
                  </div>
                </div>
              </div>

              {/* Tabela */}
              <div className="table-responsive">
                <table className="table table-custom" style={{fontSize:12.5}}>
                  <thead>
                    <tr>
                      <th style={{width:90}}>Código</th>
                      <th>Conta Contábil</th>
                      <th style={{width:70,textAlign:"center"}}>Tipo</th>
                      <th style={{width:120,textAlign:"right"}}>Débito Prev.</th>
                      <th style={{width:120,textAlign:"right"}}>Déb. Realizado</th>
                      <th style={{width:120,textAlign:"right"}}>Créd. Previsto</th>
                      <th style={{width:120,textAlign:"right"}}>Créd. Realizado</th>
                      <th style={{width:110,textAlign:"right"}}>A Receber</th>
                      <th style={{width:110,textAlign:"right"}}>Saldo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.contas.length === 0
                      ? <tr><td colSpan={6} style={{textAlign:"center",padding:"24px",color:"var(--gray-400)"}}>Nenhum lançamento no período</td></tr>
                      : data.contas.map((c,i) => (
                        <tr key={c.id} style={{background:i%2===0?"#fff":"var(--gray-50)"}}>
                          <td style={{color:"var(--gray-400)",fontSize:11}}>{c.classificacaoContabil||""}</td>
                          <td>
                            <div style={{fontWeight:500}}>{c.descConta}</div>
                            {c.grpContabil && <div style={{fontSize:11,color:"var(--gray-400)"}}>{c.grpContabil}</div>}
                          </td>
                          <td style={{textAlign:"center"}}>
                            <span style={{background:c.tpGrupo==="Credito"?"#EFF6FF":"#FEE2E2",color:c.tpGrupo==="Credito"?"#1D4ED8":"#991B1B",padding:"1px 8px",borderRadius:10,fontSize:11,fontWeight:600}}>
                              {c.tpGrupo}
                            </span>
                          </td>
                          <td style={{textAlign:"right",color:"#991B1B"}}>{fmtM(c.debito)}</td>
                          <td style={{textAlign:"right",color:"#991B1B",fontWeight:600}}>{fmtM(c.debitoRealizado||0)}</td>
                          <td style={{textAlign:"right",color:"#166534"}}>{fmtM(c.credito)}</td>
                          <td style={{textAlign:"right",color:"#166534",fontWeight:600}}>{fmtM(c.creditoRealizado||0)}</td>
                          <td style={{textAlign:"right",color:c.creditoPendente>0?"#92400E":"#94A3B8",fontSize:12}}>{fmtM(c.creditoPendente||0)}</td>
                          <td style={{textAlign:"right",fontWeight:700,color:c.saldoFinal>=0?"#1D4ED8":"#991B1B"}}>{fmtM(c.saldoFinal)}</td>
                        </tr>
                      ))
                    }
                  </tbody>
                  {data.contas.length > 0 && (
                    <tfoot>
                      <tr style={{background:"var(--primary)",color:"#fff",fontWeight:700}}>
                        <td colSpan={3} style={{padding:"8px 12px"}}>TOTAIS</td>
                        <td style={{padding:"8px 12px",textAlign:"right"}}>{fmtM(data.totais.vlrDebito)}</td>
                        <td style={{padding:"8px 12px",textAlign:"right"}}>{fmtM(data.totais.vlrDebitoRealizado||0)}</td>
                        <td style={{padding:"8px 12px",textAlign:"right"}}>{fmtM(data.totais.vlrCredito)}</td>
                        <td style={{padding:"8px 12px",textAlign:"right"}}>{fmtM(data.totais.vlrCreditoRealizado||0)}</td>
                        <td style={{padding:"8px 12px",textAlign:"right"}}>{fmtM((data.totais.vlrCredito||0)-(data.totais.vlrCreditoRealizado||0))}</td>
                        <td style={{padding:"8px 12px",textAlign:"right"}}>{fmtM(data.totais.vlrCredito-data.totais.vlrDebito)}</td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            </div>
          )}

          {/* ── Inadimplência Results ── */}
          {aba==="inadimplencia" && data && (() => {
            const fM = v => Number(v||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});
            const fD = d => { try{ return new Date(d+"T12:00:00").toLocaleDateString("pt-BR"); }catch{ return d||"—"; } };
            return (
              <div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:16}}>
                  {[
                    {l:"Unidades Inadimplentes", v:data.total.qtd,        fmt:"n"},
                    {l:"Total Original",         v:data.total.original,   fmt:"m"},
                    {l:"Total Atualizado",       v:data.total.atualizado, fmt:"m"},
                  ].map(s=>(
                    <div key={s.l} style={{background:"var(--bg-danger-soft)",borderRadius:10,padding:"14px 16px",textAlign:"center"}}>
                      <div style={{fontSize:22,fontWeight:700,color:"#991B1B"}}>{s.fmt==="m"?fM(s.v):s.v}</div>
                      <div style={{fontSize:11,color:"#991B1B",marginTop:3}}>{s.l}</div>
                    </div>
                  ))}
                </div>
                {/* Aging bands */}
                {data.data.length > 0 && (() => {
                  const bands = [
                    {l:"Até 30 dias",    min:0,  max:30,  color:"#FEF9C3", text:"#854D0E"},
                    {l:"31 a 60 dias",   min:31, max:60,  color:"#FED7AA", text:"#9A3412"},
                    {l:"61 a 90 dias",   min:61, max:90,  color:"#FECACA", text:"#991B1B"},
                    {l:"Acima de 90 dias",min:91,max:9999,color:"#FCA5A5", text:"#7F1D1D"},
                  ];
                  return (
                    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:16}}>
                      {bands.map(b => {
                        const itens = data.data.filter(i=>i.diasAtraso>=b.min&&i.diasAtraso<=b.max);
                        const total = itens.reduce((a,i)=>a+i.vlrAtualizado,0);
                        return (
                          <div key={b.l} style={{background:b.color,borderRadius:10,padding:"12px 14px",textAlign:"center"}}>
                            <div style={{fontSize:18,fontWeight:700,color:b.text}}>{itens.length}</div>
                            <div style={{fontSize:11,color:b.text,fontWeight:600}}>{b.l}</div>
                            <div style={{fontSize:12,color:b.text,marginTop:2}}>{fM(total)}</div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })()}

                {data.data.length===0 ? (
                  <div style={{textAlign:"center",padding:40,background:"var(--bg-success-soft)",borderRadius:10}}>
                    <i className="bi bi-check-circle-fill" style={{fontSize:40,color:"#166534",display:"block",marginBottom:8}}/>
                    <p style={{fontWeight:600,color:"#166534"}}>Nenhuma inadimplência encontrada!</p>
                  </div>
                ) : (
                  <div style={{overflowX:"auto"}}>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                      <thead>
                        <tr style={{background:"#991B1B",color:"#fff"}}>
                          {["Unidade","Condômino","Competência","Vencimento","Dias em Atraso","Valor Original","Multa+Juros","Valor Atualizado"].map(h=>(
                            <th key={h} style={{padding:"8px 12px",textAlign:["Dias em Atraso","Valor Original","Multa+Juros","Valor Atualizado"].includes(h)?"right":"left",fontSize:11}}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {data.data.map((it,i)=>(
                          <tr key={it.id} style={{background:i%2===0?"#fff":"#fafafa",borderBottom:"1px solid #f0f0f0"}}>
                            <td style={{padding:"7px 12px",fontWeight:600}}>{it.unidade}</td>
                            <td style={{padding:"7px 12px"}}>{it.nmCondomino}</td>
                            <td style={{padding:"7px 12px",textAlign:"center"}}>{it.competencia||"—"}</td>
                            <td style={{padding:"7px 12px",textAlign:"center"}}>{fD(it.dtVencimento)}</td>
                            <td style={{padding:"7px 12px",textAlign:"right",color:"#991B1B",fontWeight:700}}>{it.diasAtraso} dias</td>
                            <td style={{padding:"7px 12px",textAlign:"right"}}>{fM(it.vlrOriginal)}</td>
                            <td style={{padding:"7px 12px",textAlign:"right",color:"#C2410C"}}>{fM(it.vlrMulta+it.vlrJuros)}</td>
                            <td style={{padding:"7px 12px",textAlign:"right",fontWeight:700,color:"#991B1B"}}>{fM(it.vlrAtualizado)}</td>
                          </tr>
                        ))}
                        <tr style={{background:"#991B1B",color:"#fff",fontWeight:700}}>
                          <td colSpan={4} style={{padding:"8px 12px"}}>TOTAIS — {data.total.qtd} unidade{data.total.qtd!==1?"s":""}</td>
                          <td style={{padding:"8px 12px"}}></td>
                          <td style={{padding:"8px 12px",textAlign:"right"}}>{fM(data.total.original)}</td>
                          <td style={{padding:"8px 12px",textAlign:"right"}}>{fM(data.total.diferenca)}</td>
                          <td style={{padding:"8px 12px",textAlign:"right"}}>{fM(data.total.atualizado)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })()}

          {/* ── Extrato por Unidade ── */}
          {aba==="extrato" && data && (() => {
            const fM = v => Number(v||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});
            const fD = d => { try{ if(!d) return "—"; const s=String(d).includes("T")?d:d+"T12:00:00"; return new Date(s).toLocaleDateString("pt-BR"); }catch{ return d||"—"; } };
            const sColor = {Pago:"#166534",Vencido:"#991B1B",Cancelado:"#6B7280",Gerado:"#1D4ED8",Registrado:"#1D4ED8"};
            return (
              <div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                  <div>
                    <h4 style={{margin:0,color:"#1B3A6B"}}>
                      Unidade {data.unidade?.unidade}{data.unidade?.bloco?`/Bl.${data.unidade.bloco}`:""}
                      {data.unidade?.nmProprietario && <span style={{fontWeight:400,fontSize:14,color:"var(--gray-500)"}}> — {data.unidade.nmProprietario}</span>}
                    </h4>
                    <div style={{fontSize:12,color:"var(--gray-500)"}}>
                      {data.condo?.nmFantasia||data.condo?.nmCondominio} · {fD(data.periodo.dtIni)} a {fD(data.periodo.dtFim)}
                    </div>
                  </div>
                  <button className="btn btn-outline-primary btn-sm"
                    onClick={handleImprimir}>
                    <i className="bi bi-printer me-1"/>Imprimir
                  </button>
                </div>
                {/* KPIs */}
                <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:16}}>
                  {[
                    {l:"Total cobrado", v:data.totais.cobranca, bg:"#EFF6FF", txt:"#1D4ED8"},
                    {l:"Total pago",    v:data.totais.pago,     bg:"#F0FDF4", txt:"#166534"},
                    {l:"Em aberto",     v:data.totais.aberto,   bg:"#FEF2F2", txt:"#991B1B"},
                  ].map(s=>(
                    <div key={s.l} style={{background:s.bg,borderRadius:10,padding:"12px 16px",textAlign:"center"}}>
                      <div style={{fontSize:20,fontWeight:700,color:s.txt}}>{fM(s.v)}</div>
                      <div style={{fontSize:11,color:s.txt}}>{s.l}</div>
                    </div>
                  ))}
                </div>
                {/* Boletos */}
                <div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                    <thead>
                      <tr style={{background:"#1B3A6B",color:"#fff"}}>
                        {["Competência","Vencimento","Pagamento","Valor","Pago","Status"].map(h=>(
                          <th key={h} style={{padding:"8px 10px",textAlign:["Valor","Pago"].includes(h)?"right":"left",fontSize:11}}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {data.boletos.map((b,i)=>(
                        <tr key={b.id} style={{background:i%2===0?"#fff":"#F8FAFC",borderBottom:"1px solid var(--border-subtle)"}}>
                          <td style={{padding:"6px 10px"}}>{b.competencia||"—"}</td>
                          <td style={{padding:"6px 10px"}}>{fD(b.dtVencimento)}</td>
                          <td style={{padding:"6px 10px"}}>{b.dtPagamento?fD(b.dtPagamento):"—"}</td>
                          <td style={{padding:"6px 10px",textAlign:"right"}}>{fM(b.vlrBoleto)}</td>
                          <td style={{padding:"6px 10px",textAlign:"right"}}>{b.vlrPago?fM(b.vlrPago):"—"}</td>
                          <td style={{padding:"6px 10px",fontWeight:600,color:sColor[b.status]||"#374151"}}>{b.status}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* Lançamentos avulsos */}
                {data.lancamentos.length > 0 && (
                  <div style={{marginTop:16}}>
                    <h6 style={{color:"#1B3A6B",marginBottom:8}}>Lançamentos Avulsos</h6>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                      <thead>
                        <tr style={{background:"var(--bg-page)"}}>
                          {["Descrição","Vencimento","Pagamento","Valor","Status"].map(h=>(
                            <th key={h} style={{padding:"6px 10px"}}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {data.lancamentos.map((l,i)=>(
                          <tr key={l.id} style={{borderBottom:"1px solid var(--border-subtle)"}}>
                            <td style={{padding:"5px 10px"}}>{l.descricao}</td>
                            <td style={{padding:"5px 10px"}}>{fD(l.dtVencimento)}</td>
                            <td style={{padding:"5px 10px"}}>{l.dtPagamento?fD(l.dtPagamento):"—"}</td>
                            <td style={{padding:"5px 10px",textAlign:"right"}}>{fM(l.vlrParcela)}</td>
                            <td style={{padding:"5px 10px",color:sColor[l.status]||"#374151",fontWeight:600}}>{l.status}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })()}

          {/* Prestacao de Contas */}
          {aba==="prestacao" && data && (()=>{
            const fM = v => Number(v||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});
            const fD = d => { try{ return new Date(d+"T12:00:00").toLocaleDateString("pt-BR"); }catch{ return d||"--"; } };
            return (
              <div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                  <div>
                    <h4 style={{margin:0,color:"#1B3A6B"}}>{data.condo?.nmFantasia||data.condo?.nmCondominio}</h4>
                    <div style={{fontSize:12,color:"var(--gray-500)"}}>Prestacao de Contas -- {fD(data.dtIni)} a {fD(data.dtFim)}</div>
                  </div>
                  <div className="d-flex gap-2">
                    <button className="btn btn-outline-primary btn-sm"
                      onClick={()=>window.open(`/api/relatorios/prestacao/imprimir?idCondominio=${idCondo}&dtIni=${dtIni}&dtFim=${dtFim}`,"_blank")}>
                      <i className="bi bi-printer me-1"/>Imprimir
                    </button>
                    <button className="btn btn-outline-success btn-sm"
                      onClick={async()=>{
                        const ok = await askConfirm({
                          titulo:   "Enviar prestação de contas?",
                          mensagem: "Enviar a prestação de contas para todos os condôminos com e-mail cadastrado?",
                          textoOk:  "Enviar",
                          perigo:   false,
                        });
                        if(!ok) return;
                        try {
                          await relatoriosService.enviarPrestacao({idCondominio:idCondo,dtIni,dtFim});
                          notify("Prestação enviada com sucesso.", "success");
                        }
                        catch(e){ notify(e?.message || "Erro ao enviar prestação.", "danger"); }
                      }}>
                      <i className="bi bi-send me-1"/>Enviar por Email
                    </button>
                  </div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:10,marginBottom:20}}>
                  {[
                    {l:"Total Receitas", v:data.receitas.total, bg:"#F0FDF4", txt:"#166534"},
                    {l:"Total Despesas", v:data.despesas.total, bg:"#FEF2F2", txt:"#991B1B"},
                    {l:"Saldo do Periodo",v:data.saldoMes, bg:data.saldoMes>=0?"#EFF6FF":"#FFF7ED", txt:data.saldoMes>=0?"#1D4ED8":"#C2410C"},
                    {l:"Saldo Bancario",  v:data.saldoBancario, bg:"#F8FAFC", txt:"#334155"},
                  ].map(s=>(
                    <div key={s.l} style={{background:s.bg,borderRadius:10,padding:"14px 16px",textAlign:"center"}}>
                      <div style={{fontSize:22,fontWeight:700,color:s.txt}}>{fM(s.v)}</div>
                      <div style={{fontSize:11,color:s.txt,fontWeight:600,marginTop:3}}>{s.l}</div>
                    </div>
                  ))}
                </div>
                <div style={{background:"var(--bg-danger-soft)",borderRadius:10,padding:"12px 16px",marginBottom:16}}>
                  <span style={{fontWeight:700,color:"#991B1B"}}>Inadimplencia: </span>
                  <span style={{color:"#7F1D1D",fontSize:13}}>
                    {data.inadimplencia.qtdUnidades} unidade(s) em atraso ({data.inadimplencia.pctUnidades}%) --
                    {fM(data.inadimplencia.vlrTotal)} em aberto
                  </span>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
                  <div>
                    <h6 style={{color:"#166534",marginBottom:8}}>Receitas</h6>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                      <thead><tr style={{background:"var(--bg-success-soft)"}}>
                        <th style={{padding:"6px 8px"}}>Conta</th>
                        <th style={{padding:"6px 8px",textAlign:"right"}}>Valor</th>
                      </tr></thead>
                      <tbody>
                        {data.receitas.itens.map((r,i)=>(
                          <tr key={i} style={{borderBottom:"1px solid var(--border-subtle)"}}>
                            <td style={{padding:"5px 8px"}}>{r.descConta||"Nao classificado"}</td>
                            <td style={{padding:"5px 8px",textAlign:"right",color:"#166534",fontWeight:600}}>{fM(r.vlrTotal)}</td>
                          </tr>
                        ))}
                        <tr style={{background:"var(--bg-success-soft)",fontWeight:700}}>
                          <td style={{padding:"6px 8px"}}>TOTAL</td>
                          <td style={{padding:"6px 8px",textAlign:"right",color:"#166534"}}>{fM(data.receitas.total)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <h6 style={{color:"#991B1B",marginBottom:8}}>Despesas</h6>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                      <thead><tr style={{background:"var(--bg-danger-soft)"}}>
                        <th style={{padding:"6px 8px"}}>Conta</th>
                        <th style={{padding:"6px 8px",textAlign:"right"}}>Valor</th>
                      </tr></thead>
                      <tbody>
                        {data.despesas.itens.map((r,i)=>(
                          <tr key={i} style={{borderBottom:"1px solid var(--border-subtle)"}}>
                            <td style={{padding:"5px 8px"}}>{r.descConta||"Nao classificado"}</td>
                            <td style={{padding:"5px 8px",textAlign:"right",color:"#991B1B",fontWeight:600}}>{fM(r.vlrTotal)}</td>
                          </tr>
                        ))}
                        <tr style={{background:"var(--bg-danger-soft)",fontWeight:700}}>
                          <td style={{padding:"6px 8px"}}>TOTAL</td>
                          <td style={{padding:"6px 8px",textAlign:"right",color:"#991B1B"}}>{fM(data.despesas.total)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            );
          })()}

          {/* ── Consumo ── */}
          {aba==="consumo" && data && (()=>{
            const fM = v => Number(v||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});
            const tpColor = {Agua:"#1D4ED8",Gas:"#C2410C",Energia:"#D97706"};
            return (
              <div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                  <h4 style={{margin:0,color:"#1B3A6B"}}>Relatório de Consumo</h4>
                  <button className="btn btn-outline-primary btn-sm"
                    onClick={async()=>{
                      const r=await relatoriosService.imprimirConsumo({idCondominio:idCondo,dtIni,dtFim,tpConsumo:filtroConsumo});
                      const w=window.open("","_blank","width=1000,height=820");
                      w.document.write(r.html); w.document.close();
                    }}>
                    <i className="bi bi-printer me-1"/>Imprimir
                  </button>
                </div>
                {/* Totais por tipo */}
                {Object.entries(data.totais||{}).length > 0 && (
                  <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap"}}>
                    {Object.entries(data.totais).map(([tp,t])=>(
                      <div key={tp} style={{background:"var(--bg-highlight)",borderRadius:10,padding:"12px 16px",minWidth:140}}>
                        <div style={{fontSize:11,fontWeight:600,color:tpColor[tp]||"#1D4ED8"}}>{tp}</div>
                        <div style={{fontSize:18,fontWeight:700,color:tpColor[tp]||"#1D4ED8"}}>{fM(t.vlrTotal)}</div>
                        <div style={{fontSize:11,color:"var(--gray-500)"}}>{t.unidades} unidade(s)</div>
                      </div>
                    ))}
                  </div>
                )}
                {data.leituras?.length===0 ? (
                  <div style={{textAlign:"center",padding:40,color:"var(--gray-400)"}}>
                    Nenhuma leitura no período
                  </div>
                ) : (
                  <div style={{overflowX:"auto"}}>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                      <thead>
                        <tr style={{background:"#1B3A6B",color:"#fff"}}>
                          {["Unidade","Tipo","Competência","Leit. Ant.","Leit. Atu.","Consumo","Valor","Status"].map(h=>(
                            <th key={h} style={{padding:"7px 8px",textAlign:["Leit. Ant.","Leit. Atu.","Consumo","Valor"].includes(h)?"right":"left",fontSize:11}}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {data.leituras.map((l,i)=>(
                          <tr key={i} style={{background:i%2===0?"#fff":"#F8FAFC",borderBottom:"1px solid var(--border-subtle)"}}>
                            <td style={{padding:"5px 8px",fontWeight:600}}>{l.unidade}{l.bloco?`/Bl.${l.bloco}`:""}</td>
                            <td style={{padding:"5px 8px"}}>
                              <span style={{background:"var(--bg-highlight)",color:tpColor[l.tpConsumo]||"#1D4ED8",
                                padding:"1px 6px",borderRadius:6,fontSize:10,fontWeight:600}}>
                                {l.tpConsumo}
                              </span>
                            </td>
                            <td style={{padding:"5px 8px"}}>{l.competencia}</td>
                            <td style={{padding:"5px 8px",textAlign:"right"}}>{l.leituraAnterior}</td>
                            <td style={{padding:"5px 8px",textAlign:"right"}}>{l.leituraAtual}</td>
                            <td style={{padding:"5px 8px",textAlign:"right",fontWeight:700}}>{l.consumo}</td>
                            <td style={{padding:"5px 8px",textAlign:"right"}}>{fM(l.vlrTotal)}</td>
                            <td style={{padding:"5px 8px",color:l.status==="Faturado"?"#166534":"#C2410C",fontWeight:600}}>{l.status||"—"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })()}

          {!data && !loading && idCondo && (
            <div style={{textAlign:"center",padding:"48px 0",color:"var(--gray-400)"}}>
              <i className="bi bi-bar-chart-line" style={{fontSize:40,display:"block",marginBottom:8}}/>
              <p style={{fontSize:13}}>Defina os filtros e clique em <strong>Gerar {aba==="dre"?"DRE":aba==="balancete"?"Balancete":aba==="inadimplencia"?"Inadimplência":aba==="extrato-analitico"?"Extrato Analítico":aba==="extrato"?"Extrato":aba==="prestacao"?"Prestação":aba==="consumo"?"Consumo":aba==="demonstrativo"?"Demonstrativo":"Relatório"}</strong></p>
            </div>
          )}
        </div>

          {/* ── Extrato Analítico ── */}
          {aba==="extrato-analitico" && data && (
            <div>
              <div className="row g-3 mb-4">
                {[
                  {label:"Total Receitas",bg:"#EFF6FF",clr:"#1D4ED8",val:data.totais?.receitas},
                  {label:"Total Despesas",bg:"#FEF2F2",clr:"#991B1B",val:data.totais?.despesas},
                  {label:"Saldo",bg:data.totais?.saldo>=0?"#F0FDF4":"#FEF2F2",
                   clr:data.totais?.saldo>=0?"#166534":"#991B1B",val:data.totais?.saldo},
                ].map(cd=>(
                  <div key={cd.label} className="col-md-4">
                    <div style={{background:cd.bg,borderRadius:10,padding:"16px",textAlign:"center"}}>
                      <div style={{fontSize:12,color:cd.clr,fontWeight:600,marginBottom:4}}>{cd.label}</div>
                      <div style={{fontSize:22,fontWeight:700,color:cd.clr}}>{fmtM(cd.val)}</div>
                    </div>
                  </div>
                ))}
              </div>
              {(data.contas||[]).length===0 && (
                <div style={{textAlign:"center",padding:32,color:"var(--gray-400)"}}>
                  <i className="bi bi-inbox" style={{fontSize:32}}/><br/>Nenhum lançamento no período.
                </div>
              )}
              {(data.contas||[]).map(ct=>(
                <div key={ct.idConta||0} style={{marginBottom:12,border:"1px solid var(--gray-200)",borderRadius:10,overflow:"hidden"}}>
                  <div style={{background:"var(--gray-50)",padding:"10px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span>
                      {ct.classificacaoContabil && <span style={{fontSize:11,color:"var(--gray-400)",marginRight:6}}>{ct.classificacaoContabil}</span>}
                      <strong style={{fontSize:13}}>{ct.descConta}</strong>
                      <span style={{fontSize:11,color:"var(--gray-400)",marginLeft:6}}>({ct.lancamentos?.length||0} lançamentos)</span>
                    </span>
                    <span style={{display:"flex",gap:12,fontSize:12}}>
                      <span style={{color:"#166534"}}>Rec: <strong>{fmtM(ct.totalReceitas)}</strong></span>
                      <span style={{color:"#991B1B"}}>Desp: <strong>{fmtM(ct.totalDespesas)}</strong></span>
                      <strong style={{color:ct.saldo>=0?"#166534":"#991B1B"}}>Saldo: {fmtM(ct.saldo)}</strong>
                    </span>
                  </div>
                  <table className="table table-sm mb-0" style={{fontSize:12.5}}>
                    <thead style={{background:"var(--gray-50)"}}>
                      <tr><th style={{width:90}}>Tipo</th><th>Descrição</th><th style={{width:100}}>Data</th><th className="text-end" style={{width:120}}>Valor</th></tr>
                    </thead>
                    <tbody>
                      {(ct.lancamentos||[]).map((l,i)=>(
                        <tr key={i} style={{background:l.isReceita?"rgba(220,252,231,0.3)":"rgba(254,226,226,0.25)"}}>
                          <td>
                            <span style={{fontSize:10,padding:"2px 7px",borderRadius:10,fontWeight:600,
                              background:l.isReceita?"#DCFCE7":"#FEE2E2",
                              color:l.isReceita?"#166534":"#991B1B"}}>
                              {l.isReceita?"Receita":"Despesa"}
                            </span>
                          </td>
                          <td style={{color:"var(--gray-600)"}}>{l.descricao}</td>
                          <td style={{color:"var(--gray-500)"}}>{fmtD(l.dtLanc)}</td>
                          <td className="text-end" style={{fontWeight:600,color:l.isReceita?"#166534":"#991B1B"}}>{fmtM(l.vlr)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          )}

          {aba==="demonstrativo" && data && (
            <div>
              <div style={{background:"var(--bg-highlight)",borderRadius:10,padding:"14px 20px",marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,fontSize:14}}>Saldo em {new Date(dtIni+"T12:00:00").toLocaleDateString("pt-BR")}</span>
                <span style={{fontWeight:800,fontSize:18,color:"#1D4ED8"}}>{fmtM(data.saldoAnterior)}</span>
              </div>
              <div style={{marginBottom:24}}>
                <div style={{fontWeight:700,fontSize:15,color:"#166534",borderBottom:"2px solid #166534",paddingBottom:4,marginBottom:12}}>RECEITAS</div>
                {data.receitas?.grupos?.map((grp,gi)=>(
                  <div key={gi} style={{marginBottom:16}}>
                    {data.receitas.grupos.length>1&&<div style={{fontWeight:600,fontSize:13,color:"var(--gray-500)",marginBottom:6,textTransform:"uppercase"}}>{grp.descricao}</div>}
                    {grp.itens.map((it,ii)=>(
                      <div key={ii} style={{display:"flex",justifyContent:"space-between",padding:"4px 16px",fontSize:13}}>
                        <span>{it.descConta}</span><span style={{fontWeight:500}}>{fmtM(it.vlrTotal)}</span>
                      </div>
                    ))}
                    {data.receitas.grupos.length>1&&(
                      <div style={{display:"flex",justifyContent:"space-between",padding:"4px 16px",fontWeight:700,fontSize:13,borderTop:"1px solid var(--border-color)",marginTop:4}}>
                        <span>Total {grp.descricao}</span><span style={{color:"#166534"}}>{fmtM(grp.total)}</span>
                      </div>
                    )}
                  </div>
                ))}
                <div style={{display:"flex",justifyContent:"space-between",padding:"8px 12px",background:"var(--bg-success-soft)",borderRadius:8,fontWeight:700,fontSize:14,marginTop:8}}>
                  <span>TOTAL DE RECEITAS</span><span style={{color:"#166534"}}>{fmtM(data.receitas?.total)}</span>
                </div>
              </div>
              <div style={{marginBottom:24}}>
                <div style={{fontWeight:700,fontSize:15,color:"#991B1B",borderBottom:"2px solid #991B1B",paddingBottom:4,marginBottom:12}}>DESPESAS</div>
                {data.despesas?.grupos?.map((grp,gi)=>(
                  <div key={gi} style={{marginBottom:16}}>
                    <div style={{fontWeight:600,fontSize:13,color:"var(--gray-600)",marginBottom:4,textTransform:"uppercase"}}>{grp.descricao}</div>
                    {grp.itens.map((it,ii)=>(
                      <div key={ii} style={{display:"flex",justifyContent:"space-between",padding:"4px 32px",fontSize:13}}>
                        <span>{it.descConta}</span><span style={{fontWeight:500}}>{fmtM(it.vlrTotal)}</span>
                      </div>
                    ))}
                    <div style={{display:"flex",justifyContent:"space-between",padding:"4px 16px",fontWeight:700,fontSize:13,borderTop:"1px solid var(--border-color)",marginTop:4}}>
                      <span>Total {grp.descricao}</span><span style={{color:"#991B1B"}}>{fmtM(grp.total)}</span>
                    </div>
                  </div>
                ))}
                <div style={{display:"flex",justifyContent:"space-between",padding:"8px 12px",background:"var(--bg-danger-soft)",borderRadius:8,fontWeight:700,fontSize:14,marginTop:8}}>
                  <span>TOTAL DE DESPESAS</span><span style={{color:"#991B1B"}}>{fmtM(data.despesas?.total)}</span>
                </div>
              </div>
              <div style={{display:"flex",justifyContent:"space-between",padding:"10px 16px",background:data.movLiquido>=0?"#DCFCE7":"#FEE2E2",borderRadius:8,fontWeight:700,fontSize:15,marginBottom:24}}>
                <span>Movimento Líquido (Receitas - Despesas)</span>
                <span style={{color:data.movLiquido>=0?"#166534":"#991B1B"}}>{fmtM(data.movLiquido)}</span>
              </div>
              <div style={{background:"var(--bg-highlight)",borderRadius:10,padding:"14px 20px",marginBottom:24,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontWeight:700,fontSize:14}}>Saldo em {new Date(dtFim+"T12:00:00").toLocaleDateString("pt-BR")}</span>
                <span style={{fontWeight:800,fontSize:18,color:"#1D4ED8"}}>{fmtM(data.saldoAtual)}</span>
              </div>
              <div>
                <div style={{fontWeight:700,fontSize:15,borderBottom:"2px solid #CBD5E1",paddingBottom:4,marginBottom:12}}>RESUMO FINANCEIRO</div>
                <p style={{fontSize:12,color:"var(--gray-600)",margin:"0 0 12px",lineHeight:1.45}}>
                  Por conta: <strong>Créditos / Débitos</strong> do extrato bancário no período (inclui lançamentos conciliados).
                  Na linha <strong>TOTAL</strong>, as duas colunas centrais mostram os mesmos totais de <strong>Receitas</strong> e <strong>Despesas</strong> do regime caixa (contas a receber/pagar), como nas seções acima.
                </p>
                <table className="table table-custom" style={{fontSize:13}}>
                  <thead><tr>
                    <th>Conta Bancária</th>
                    <th style={{textAlign:"right"}}>Saldo Anterior</th>
                    <th style={{textAlign:"right",color:"#166534"}}>Créditos <span style={{fontSize:10,fontWeight:500,color:"var(--gray-500)"}}>(extrato)</span></th>
                    <th style={{textAlign:"right",color:"#991B1B"}}>Débitos <span style={{fontSize:10,fontWeight:500,color:"var(--gray-500)"}}>(extrato)</span></th>
                    <th style={{textAlign:"right"}}>Saldo Atual</th>
                  </tr></thead>
                  <tbody>
                    {data.resumoContas?.map((c,i)=>(
                      <tr key={i}>
                        <td style={{fontWeight:500}}>{c.nmConta}</td>
                        <td style={{textAlign:"right"}}>{fmtM(c.saldoAnterior)}</td>
                        <td style={{textAlign:"right",color:"#166534",fontWeight:500}}>{fmtM(c.creditos)}</td>
                        <td style={{textAlign:"right",color:"#991B1B",fontWeight:500}}>{fmtM(c.debitos)}</td>
                        <td style={{textAlign:"right",fontWeight:700,color:c.saldoAtual>=0?"#1D4ED8":"#991B1B"}}>{fmtM(c.saldoAtual)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr style={{background:"var(--primary)",color:"#fff",fontWeight:700}}>
                      <td style={{padding:"8px 12px"}}>TOTAL</td>
                      <td style={{padding:"8px 12px",textAlign:"right"}}>{fmtM(data.saldoAnterior)}</td>
                      <td style={{padding:"8px 12px",textAlign:"right"}}>{fmtM(data.receitas?.total)}</td>
                      <td style={{padding:"8px 12px",textAlign:"right"}}>{fmtM(data.despesas?.total)}</td>
                      <td style={{padding:"8px 12px",textAlign:"right"}}>{fmtM(data.saldoAtual)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          )}
      </div>

      {/* ── Banner global de notificação ── */}
      {banner && (
        <div style={{
          position:"fixed", top:70, left:0, right:0,
          zIndex:1100, display:"flex", justifyContent:"center",
          pointerEvents:"none", padding:"0 16px"
        }}>
          <div style={{ maxWidth:520, width:"100%", pointerEvents:"auto" }}>
            <Banner tipo={banner.tipo} onClose={() => setBanner(null)}>
              {banner.mensagem}
            </Banner>
          </div>
        </div>
      )}

      {/* ── Modal de confirmação global ── */}
      {confirmacao && (
        <ConfirmModal
          titulo={confirmacao.titulo}
          mensagem={confirmacao.mensagem}
          textoOk={confirmacao.textoOk}
          perigo={confirmacao.perigo}
          onConfirm={() => { confirmacao.resolve(true); setConfirmacao(null); }}
          onCancel={() => { confirmacao.resolve(false); setConfirmacao(null); }}
        />
      )}
    </div>
  );
}
